<template>
    <div>
        <Modal :show="showModal" :close="() => {}">
            <template #header>
                <h1 class="header">{{ $t("modal.confirm-selection.header") }}</h1>
            </template>

            <template #body>
                <div class="body-text">
                    {{ $t("modal.confirm-selection.body", { amount: amountFormatted }) }}
                </div>
            </template>
            <template #footer>
                <div class="text-right">
                    <button id="modal-confirm-btn" class="confirm-button" @click="closeModal(true)">Confirm</button>
                    <button id="modal-cancel-btn" class="cancel-button" @click="closeModal(false)">Cancel</button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"
    import { formatCurrency } from "@/util/currency"

    export default {
        name: "ConfirmSelection",
        components: {
            Modal,
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            },

            amount: {
                type: Number,
            },
        },
        computed: {
            amountFormatted() {
                return formatCurrency(this.amount * 100)
            },
        },
        methods: {
            closeModal(confirm) {
                this.$emit("close-confirm-modal")
                if (confirm === true) {
                    this.$emit("confirm-less-amount")
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .confirm-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
        color: $secondary-color;
    }

    .cancel-button {
        float: right;
        font-size: to_rem(18px);
        margin: 0px 8px;
    }
</style>
